(function () {
    'use strict';

    angular
        .module('app.shared')
        .config(config);
    
    config.$inject = ['DoubleClickProvider'];
    function config(DoubleClickProvider) {
        DoubleClickProvider.defineSlot('/61175202/GC-EN-Member-LB-728x90', [728, 90], 'divTopAdEn');
        DoubleClickProvider.defineSlot('/61175202/GC-FR-Member-LB-728x90', [728, 90], 'divTopAdFr');
        DoubleClickProvider.defineSlot('/61175202/scorecentre-pop', [320, 480], 'divPostAd');
    };
})();